export const withNotApplicableFallback = (value) => {
  return value || 'N/A';
};

export const withDashFallback = (value) => {
  return value || '-';
};
